export const FirebaseConfig = {
	"apiKey": "AIzaSyDAm-IL2gI18hPsGW5W1NWKWgdx46UY_Zs",
	"authDomain": "rigzie-82d74.firebaseapp.com",
	"databaseURL": "https://rigzie-82d74-default-rtdb.firebaseio.com",
	"projectId": "rigzie-82d74",
	"storageBucket": "rigzie-82d74.appspot.com",
	"messagingSenderId": "754637127437",
	"appId": "1:754637127437:web:bbf49153de9e392324fa44",
	"measurementId": "G-MCMVCB7DQ2"
};